<template>
    <div class="h-full">
        <div class="relative">
            <span
                class="absolute top-0 right-0 w-48 bg-output-blue-200 h-28"
            ></span>
            <span
                class="absolute top-0 h-48 w-80 bg-output-primary right-52"
            ></span>
            <span
                class="absolute right-0 h-48 w-36 bg-output-blue-400 top-40"
            ></span>
        </div>
        <div class="cover-container page-content">
            <span class="cover-sub-heading">Business Plan</span>
            <div class="cover-main ">
                <h1 class="cover-heading">
                    {{ entrepriseName }}
                </h1>
                <span class="cover-heading-date"
                    >{{ cuurentYear }} - {{ finalYear }}</span
                >
            </div>
            <table class="cover-details">
                <tr>
                    <th>
                        Date
                    </th>
                    <td>
                        {{ cuurentYear }}
                    </td>
                </tr>
                <tr>
                    <th>
                        Déclaration de confidentialité
                    </th>
                    <td>
                        Le présent document reprend uniquement les données
                        communiquées par la société
                        <span class="capitalize">{{ entrepriseName }}</span
                        >. Toutes les informations qu'il contient sont
                        considérées comme confidentielles.
                    </td>
                </tr>
            </table>
        </div>
        <div class="relative">
            <span
                class="absolute bottom-0 left-0 w-48 bg-output-blue-200 h-28"
            ></span>
            <span
                class="absolute bottom-0 h-48 w-80 bg-output-primary left-52"
            ></span>
            <span
                class="absolute left-0 h-48 w-36 bg-output-blue-400 bottom-40"
            ></span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        entrepriseName: {
            type: String,
            required: true
        },
        cuurentYear: {
            type: [String, Number],
            required: true
        },
        finalYear: {
            type: [String, Number],
            required: true
        }
    }
};
</script>

<style src="@/assets/styles/output2.css" />
